module.exports = __webpack_public_path__ + "img/png_jsgzl_1@2x.55021540.png";